import React, { useEffect, useState } from "react";
import Dialog from "../../../../components/Dialog/Dialog";
import { CircularProgress, withStyles } from "@material-ui/core";
import CloseIcon from "../../../../components/Icon/Close";
import InputForm from "../../../../components/Input/InputForm";
import { Button } from "../../../../components/ui/Buttons";
import { TextFieldSearch } from "../../../../components/TextField";
import TrashIcon from "../../../../components/Icon/Trash";
import MensagemListaVazia from "../../../../components/Mensagem/MensagemListaVazia";
import { findProcedimentos } from "../../../../services/ProcedimentoService";
import {
  findAllProcedimentosByExameDasaId,
  atualizarProcedimentosExame,
} from "../../../../services/ExamesService";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";

const ModalExameSelecionado = observer(
  ({ classes, open, handleClose, exameSelecionado, exameStore }) => {
    const [procedimentosSelected, setProcedimentosSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      findAllProcedimentosExame();
    }, []);

    const findAllProcedimentosExame = async () => {
      try {
        setIsLoading(true);
        const response = await findAllProcedimentosByExameDasaId({
          exameId: exameSelecionado?.id,
        });
        setProcedimentosSelected(response);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    const handleClickExcluir = (index) => {
      const procedimentos = procedimentosSelected.filter((_, i) => i !== index);

      setProcedimentosSelected(procedimentos);
    };

    const loadProcedimentos = async (search, loadedOptions, { page }) => {
      try {
        const response = await findProcedimentos({
          pageableDTO: {
            pageNumber: page,
            pageSize: 10,
            sortDir: "ASC",
            sortField: "nome",
          },
          nome: search,
          ativo: true,
        });

        const { content, last } = response.data.data.findAllProcedimentos;
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    };

    const handleChange = (procedimentos) => {
      if(!procedimentos) return;
      if (procedimentosSelected.some((item) => item?.id === procedimentos?.id))
        return;
      setProcedimentosSelected([...procedimentosSelected, procedimentos]);
    };

    const handleClickSalvar = async () => {
      try {
        setIsLoading(true);
        const variables = {
          exameId: exameSelecionado?.id,
          procedimentos: procedimentosSelected,
        };

        const response = await atualizarProcedimentosExame(variables);
        if (response?.id) {
          exameStore.openNotification("Exame salvo com sucesso!", "success");
          handleClose();
        }
      } catch (error) {
        exameStore.openNotification("Erro ao salvar!", "error");
      } finally {
        setIsLoading(false);
      }
    };

    const disabled = procedimentosSelected?.length === 0;
    return (
      <>
        <Dialog
          open={open}
          onClose={handleClose}
          classes={{ paper: classes.dialog }}
        >
          <div className={classes.root}>
            <div className={classes.header}>
              <div className={classes.title}>Exame Selecionado</div>
                <Button
                  id="cfg-mes-btn-fec"
                  onClick={handleClose} 
                  shape='circle' 
                  bgColor='#FB7676'
                >
                  <CloseIcon />
                </Button>
            </div>
            <div className={classes.content}>
              <div className={classes.wrapperInput}>
                <label className={classes.label}>Exame</label>
                <InputForm
                  id="cfg-mes-inp-exa"
                  value={exameSelecionado?.descricao}
                  disabled
                  classes={{
                    input: classes.input,
                  }}
                />
              </div>
              <div className={classes.wrapperScroll}>
                <div className={classes.wrapper}>
                  <div className={classes.wrapperInputFilter}>
                    <label className={classes.label}>
                      Selecione o procedimento
                    </label>
                    <TextFieldSearch
                      id="cfg-mes-inp-pro"
                      placeholder="Selecione"
                      classIcons={classes.classIcons}
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadProcedimentos}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      onChange={(e) => handleChange(e)}
                      withPaginate
                      menuPlacement="auto"
                      isClearable
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </div>
                  <div className={classes.wrapperProcedimentos}>
                    <div className={classes.headerProcedimento}>
                      <div>Procedimentos </div>
                      <div>Ação </div>
                    </div>
                    <div className={classes.scrollProcedimentos}>
                      {isLoading && (
                        <div className={classes.loading}>
                          <CircularProgress />
                        </div>
                      )}

                      {!isLoading &&
                        procedimentosSelected?.length > 0 &&
                        procedimentosSelected.map((item, index) => (
                          <div
                            key={item?.id ?? index}
                            className={classes.contentProcedimento}
                          >
                            <label className={classes.label}>
                              {item?.nome}
                            </label>

                            <TrashIcon
                              id={`cfg-mes-ico-exc-${index}`}
                              size={20}
                              color="#fb7676"
                              onClick={() => handleClickExcluir(index)}
                              className={classes.icon}
                            />
                          </div>
                        ))}

                      {!isLoading && procedimentosSelected?.length === 0 && (
                        <MensagemListaVazia />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.wrapperButton}>
              <Button
                id="cfg-mes-btn-sal"
                onClick={handleClickSalvar}
                disabled={isLoading || disabled}
              >
                Salvar
              </Button>
            </div>
          </div>
        </Dialog>
      </>
    );
  },
);

const styles = {
  dialog: {
    height: "600px",
    minWidth: "800px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  root: {
    width: "100%",
    height: "100%",
    padding: "10px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },

  header: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #e5e5e5",
  },

  title: {
    fontSize: "20px",
    fontWeight: "bold",
  },

  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    gap: "10px",
  },

  wrapperInput: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    padding: "10px",
  },

  input: {
    width: "100%",
    color: "#505050",
    background: "#F2F2F2",
    border: "0 !important",
    borderRadius: "8px",
    height: "30px",
    boxSizing: "border-box",
    fontSize: "14px",
  },

  label: {
    color: "#505050",
    fontSize: "12px",
  },

  wrapper: {
    padding: "10px",
    gap: "5px",
    display: "flex",
    flexDirection: "row",
  },

  wrapperScroll: {
    flex: 1,
    minHeight: 0,
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  scroll: {
    flex: 1,
    overflowY: "auto",
    width: "100%",
    borderRadius: "8px",
    padding: "10px",
  },

  wrapperButton: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    paddingTop: "10px",
  },

  inputSearch: {
    width: "97%",
    background: "#F2F2F2",
    justifyContent: "center",
    fontWeight: 400,
    color: "#868686",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },

  iconButtonSearch: {
    width: "30px",
    height: "30px",
    padding: "0",
  },

  wrapperInputFilter: {
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "column",
    padding: "10px",
    background: "#f2f2f2",
    borderRadius: "8px",
  },

  classIcons: {
    fontSize: 24,
    padding: "0px",
  },

  notchedOutline: {
    border: "0",
  },

  reactSelect: {
    width: "97%",
    background: "#FFF",
  },

  wrapperProcedimentos: {
    gap: "5px",
    display: "flex",
    flexDirection: "column",
    padding: "15px",
    background: "#f2f2f2",
    borderRadius: "8px",
    height: "300px",
    width: "100%",
  },

  contentProcedimento: {
    gap: "10px",
    display: "flex",
    background: "#fff",
    width: "100%",
    padding: "9px",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },

  headerProcedimento: {
    display: "flex",
    justifyContent: "space-between",
    padding: "5px",
    fontSize: "12px",
    color: "#505050",
  },

  scrollProcedimentos: {
    gap: "10px",
    height: "100%",
    display: "flex",
    overflowY: "scroll",
    flexDirection: "column",
  },

  loading: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  icon: {
    flexShrink: 0,
    cursor: "pointer",
  },
};

const stores = ["exameStore"];
const ModalExameSelecionadoWithStyles = withStyles(styles)(
  ModalExameSelecionado,
);
export default inject(stores)(ModalExameSelecionadoWithStyles);
